<div class="system-state-overlay" *ngIf="visible" [class.loading-state]="loading">
    <div class="system-state-card" role="status" aria-live="polite">
        <div class="icon-wrap" [ngSwitch]="loading ? 'loading' : state.type">
            <div *ngSwitchCase="'loading'" class="loader-ring" aria-hidden="true"></div>
            <fa-icon *ngSwitchCase="'offline'" [icon]="['fas', 'wifi']"></fa-icon>
            <fa-icon *ngSwitchCase="'server_unavailable'" [icon]="['fas', 'cloud']"></fa-icon>
            <fa-icon *ngSwitchCase="'unexpected_error'" [icon]="['fas', 'triangle-exclamation']"></fa-icon>
        </div>

        <h2>{{ title }}</h2>
        <p>{{ description }}</p>

        <div class="actions" *ngIf="!loading">
            <button type="button" class="primary-btn" (click)="retry()">
                <fa-icon [icon]="['fas', 'arrows-rotate']"></fa-icon>
                Retry
            </button>
            <button
                    type="button"
                    class="secondary-btn"
                    *ngIf="state.type === 'unexpected_error'"
                    (click)="dismiss()">
                Dismiss
            </button>
        </div>
    </div>
</div>
